import * as React from "react";
const SvgLockClosed = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M42 45v2m-6 4h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H36a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2m10-10v-4a4 4 0 1 0-8 0v4z"
    />
  </svg>
);
export default SvgLockClosed;
